// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// Gebruik import.meta.env en de VITE_ prefix
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// --- Logging verwijderd ---
// console.log("[SupabaseClient] VITE_SUPABASE_URL:", supabaseUrl ? "LOADED" : "MISSING/EMPTY");
// console.log("[SupabaseClient] VITE_SUPABASE_ANON_KEY:", supabaseAnonKey ? "LOADED" : "MISSING/EMPTY");
// -----------------

// Simplified logging - only log an error if values are missing
if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Missing Supabase environment variables (VITE_ prefix expected)');
    throw new Error('Missing Supabase environment variables (VITE_ prefix expected)');
}

// Create Supabase client with MINIMAL configuration (rely on defaults)
// console.log("[SupabaseClient] Creating client with minimal options..."); // Logging verwijderd
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// console.log("[SupabaseClient] Client created."); // Logging verwijderd
